import ConsentType from "./consentType";
import ExternalAgency from "./externalAgency";
import PermittedEntityType from "./permittedEntityType";

export default class ConsentInfo {
    companyFullName: String;
    companyAbbrevName: String;
    permittedEntityType: PermittedEntityType;
    externalAgency: ExternalAgency;
    consentType: ConsentType;

    constructor(companyFullName: String, companyAbbrevName: String, permittedEntityType: PermittedEntityType, externalAgency: ExternalAgency, 
        consentType: ConsentType) {
        this.companyFullName = companyFullName;
        this.companyAbbrevName = companyAbbrevName;
        this.permittedEntityType = permittedEntityType;
        this.externalAgency = externalAgency;
        this.consentType = consentType;
    }
}

const emptyConsentInfo = new ConsentInfo("", "", PermittedEntityType.ExternalAgency, ExternalAgency.Guiide, ConsentType.Read);

export { emptyConsentInfo };
